import { useMutation } from "@tanstack/react-query";

import api from "../apiClient";

interface IPayload {
    email: string;
    setIsSuccess: Function;
    setApiError: Function;
    setIsProcessing: Function;
};

interface IResponse {
    error?: string;
    message: string;
    statusCode: number;
};

const useSendPasswordResetEmail = () => {
    const mutationFn = async (data: IPayload): Promise<IResponse> => {

        const res = await api.get(`users/send-password-reset-email/${data.email}`);
        return res.data;
    };

    return useMutation({
        mutationFn,
        onSuccess: (response: IResponse, variables: IPayload) => {
            if (response) {
                variables.setIsSuccess(true);
            }
        },
        onError: (error: any, variables: IPayload) => {
            variables.setApiError(error?.response?.data?.message ?? "An error occurred. Please try again.");
        },
        onSettled: (data: IResponse | undefined, error: any, variables: IPayload) => {
            variables.setIsProcessing(false);
        },
    });
};

export default useSendPasswordResetEmail;